export const ROLE_LABELS = {
  SYSTEM: "Sistem",
  SUPER_ADMIN: "PT SJI Owner / Super Admin",
  FARMER_GROUP: "Kelompok Tani",
  INVESTOR: "Pemodal Kebun",
  PRIVATE_LAND_OWNER: "Pemilik Lahan",
  INDIVIDUAL_MANAGER: "Pengelola Perorangan",
};

export const isManagerRole = (r) => r === "FARMER_GROUP" || r === "INDIVIDUAL_MANAGER";

export const ROLE_HOME = {
  SUPER_ADMIN: "/dashboard/admin",
  FARMER_GROUP: "/dashboard/kelompok-tani",
  INVESTOR: "/dashboard/investor",
  PRIVATE_LAND_OWNER: "/dashboard/pemilik-lahan",
  INDIVIDUAL_MANAGER: "/dashboard/pengelola",
};

export const STATUS_LABELS = {
  ACTIVE: "Aktif",
  INACTIVE: "Nonaktif",
  PENDING: "Menunggu",
  NONE: "Belum Diajukan",
  FROZEN: "Dibekukan",
  ARCHIVED: "Diarsipkan",
  MENUNGGU: "MENUNGGU",
  DISETUJUI: "DISETUJUI",
  DITOLAK: "DITOLAK",
  PERLU_PERBAIKAN: "PERLU PERBAIKAN",
  APPROVED: "Disetujui",
  REJECTED: "Ditolak",
  DRAFT: "Draf",
  COMPLETED: "Selesai",
  SUSPENDED: "Ditangguhkan",
  REVOKED: "Dicabut",
  SUBMITTED: "Menunggu Verifikasi PT SJI",
  UPLOADED: "Diunggah Pengelola",
  UNDER_REVIEW: "Sedang Ditinjau PT SJI",
  VERIFIED: "Terverifikasi PT SJI",
  REVISION_REQUIRED: "Perlu Perbaikan",
  OPEN: "Terbuka",
  IN_PROGRESS: "Sedang Ditangani",
  RESOLVED: "Selesai",
  LAND_PREPARATION: "Persiapan Lahan",
  PLANTING: "Penanaman Kopi",
  EARLY_GROWTH: "Pertumbuhan Awal",
  MAINTENANCE: "Perawatan Kebun",
  PRE_PRODUCTION: "Menjelang Produksi",
  INITIAL_HARVEST: "Panen Awal",
  PRODUCTIVE: "Kebun Produktif",
  PROBLEM: "Perlu Penanganan",
  AVAILABLE: "Tersedia untuk Pendanaan Kebun",
  RESERVED: "Dalam Proses Pemodal Kebun",
  INVESTED: "Sudah Mendapat Pemodal Kebun",
  NOT_LISTED: "Belum Ditawarkan",
  NEW: "Baru",
  CONTACTED: "Sudah Dihubungi",
  CLOSED: "Ditutup",
};

export const STATUS_TONE = {
  ACTIVE: "green",
  FROZEN: "red",
  ARCHIVED: "slate",
  MENUNGGU: "amber",
  DISETUJUI: "green",
  DITOLAK: "red",
  PERLU_PERBAIKAN: "amber",
  APPROVED: "green",
  PENDING: "amber",
  DRAFT: "slate",
  INACTIVE: "slate",
  COMPLETED: "blue",
  REJECTED: "red",
  SUSPENDED: "red",
  REVOKED: "red",
  SUBMITTED: "amber",
  UPLOADED: "blue",
  UNDER_REVIEW: "blue",
  VERIFIED: "green",
  REVISION_REQUIRED: "red",
  OPEN: "red",
  IN_PROGRESS: "amber",
  RESOLVED: "green",
  LAND_PREPARATION: "blue", PLANTING: "blue", EARLY_GROWTH: "blue", MAINTENANCE: "blue", PRE_PRODUCTION: "blue",
  INITIAL_HARVEST: "green", PRODUCTIVE: "green", PROBLEM: "red", AVAILABLE: "green", RESERVED: "amber",
  INVESTED: "blue", NOT_LISTED: "slate", NEW: "amber", CONTACTED: "blue", CLOSED: "slate",
};

export const COFFEE_ACTIVITY_TYPES = {
  SURVEI_LAHAN: "Survei Lahan", PEMBERSIHAN_LAHAN: "Pembersihan Lahan", PENATAAN_LAHAN: "Penataan Lahan",
  PEMBUATAN_DRAINASE: "Pembuatan Drainase", PEMBUATAN_LUBANG_TANAM: "Pembuatan Lubang Tanam",
  PENGADAAN_BIBIT: "Pengadaan Bibit Kopi", PENANAMAN_KOPI: "Penanaman Kopi", PENYULAMAN: "Penyulaman",
  PEMASANGAN_NAUNGAN: "Pemasangan Naungan", PEMUPUKAN: "Pemupukan", PENYIANGAN_GULMA: "Penyiangan Gulma",
  PEMANGKASAN: "Pemangkasan", PENGENDALIAN_HAMA: "Pengendalian Hama", PENGENDALIAN_PENYAKIT: "Pengendalian Penyakit",
  PERAWATAN_TANAMAN: "Perawatan Tanaman", INSPEKSI_KEBUN: "Inspeksi Kebun",
  PENGAMATAN_PEMBUNGAAN: "Pengamatan Pembungaan", PENGAMATAN_BUAH: "Pengamatan Buah",
  PANEN_CHERRY: "Panen Cherry Kopi", SORTASI_CHERRY: "Sortasi Cherry", PASCAPANEN: "Pascapanen",
  PENGERINGAN: "Pengeringan", HULLING: "Hulling", SORTASI_GREEN_BEAN: "Sortasi Green Bean", GRADING: "Grading",
  PENGEMASAN: "Pengemasan", PERBAIKAN_INFRASTRUKTUR: "Perbaikan Infrastruktur Kebun", KEGIATAN_LAIN: "Kegiatan Lain",
};
export const ACTIVITY_TYPES = {
  ...COFFEE_ACTIVITY_TYPES,
  PERSIAPAN_LAHAN: "Persiapan Lahan", PENANAMAN: "Penanaman Kopi", PENYEMPROTAN: "Penyemprotan",
  PENYIANGAN: "Penyiangan Gulma", IRIGASI: "Pengairan Kebun", PERAWATAN: "Perawatan Tanaman", INSPEKSI: "Inspeksi Kebun",
  PANEN: "Panen Cherry Kopi", PERBAIKAN: "Perbaikan Infrastruktur Kebun",
};
export const HARVEST_TYPES = "PANEN,PASCAPANEN,PANEN_CHERRY,SORTASI_CHERRY,PENGERINGAN,HULLING,SORTASI_GREEN_BEAN,GRADING,PENGEMASAN";
export const isHarvest = (t) => HARVEST_TYPES.split(",").includes(t);
export const productionText = (p) => !p ? "" : [
  p.cherryWeightKg != null && `Cherry ${p.cherryWeightKg} kg`, p.greenBeanWeightKg != null && `Green bean ${p.greenBeanWeightKg} kg`,
  p.cherryWeightKg > 0 && p.greenBeanWeightKg > 0 && `Rendemen ${((p.greenBeanWeightKg / p.cherryWeightKg) * 100).toFixed(1)}%`,
  p.grade && `Grade ${p.grade}`, p.moisturePct != null && `Kadar air ${p.moisturePct}%`, p.defectPct != null && `Defect ${p.defectPct}%`,
  p.beanSize && `Ukuran ${p.beanSize}`, p.cleanliness && `Kebersihan ${p.cleanliness}`, p.processingMethod && `Proses ${p.processingMethod}`,
  p.lotCode && `Lot ${p.lotCode}`, p.stockKg != null && `Stok ${p.stockKg} kg`,
  p.quantity != null && `${p.quantity} ${p.unit || ""}`, p.quality,
].filter(Boolean).join(" · ");
export const COFFEE_TYPES = { ROBUSTA: "Robusta", ARABICA: "Arabika", OTHER: "Lainnya" };
export const PROJECT_TYPES = { INVESTMENT_COFFEE_PROJECT: "Kebun Kopi dengan Pemodal Kebun", PRIVATE_MANAGED_COFFEE_PROJECT: "Kelola Kebun Kopi Milik Pribadi" };
export const isPrivateProject = (p) => p?.projectType === "PRIVATE_MANAGED_COFFEE_PROJECT";
export const LEGAL_DOC_TYPES = {
  SURAT_PEMBENTUKAN: "Surat Pembentukan / Pengukuhan", SK_KELOMPOK: "SK Kelompok Tani", AKTA_KOPERASI: "Akta Koperasi",
  NIB: "NIB", NPWP: "NPWP", REGISTRASI: "Dokumen Registrasi", PENANGGUNG_JAWAB: "Dokumen Penanggung Jawab",
  KERJA_SAMA: "Dokumen Kerja Sama", LAINNYA: "Dokumen Legal Lainnya",
};
export const ORG_TYPES = { KELOMPOK_TANI: "Kelompok Tani", KOPERASI_TANI: "Koperasi Tani" };
export const LAND_DOC_TYPES = {
  PENYERAHAN_LAHAN: "Surat Penyerahan / Penguasaan dari Ninik Mamak", SURAT_PENGUASAAN: "Surat Penguasaan Lahan",
  PERSETUJUAN_PEMEGANG_HAK: "Surat Persetujuan Pemegang Hak", HAK_KELOLA: "Surat Hak Kelola", PERJANJIAN_PENGGUNAAN: "Perjanjian Penggunaan Lahan",
  PETA_LAHAN: "Peta Lahan", FOTO_LAHAN: "Foto Lahan", LAINNYA_LAHAN: "Dokumen Pendukung Lahan Lainnya",
};
export const orgName = (g) => {
  if (!g) return "";
  const t = ORG_TYPES[g.orgType] || "Kelompok Tani";
  return /^(\[CONTOH\]\s*)?(kelompok tani|koperasi tani)/i.test(g.name) ? g.name : `${t} ${g.name}`;
};
export const DISCLAIMER = "Simulasi/proyeksi bukan jaminan hasil. Hasil aktual dapat dipengaruhi oleh kondisi tanaman, cuaca, produktivitas, kualitas, biaya operasional, harga pasar, dan faktor lainnya.";
export const OPPORTUNITY_STATUS = {
  NOT_LISTED: "Belum Ditawarkan", AVAILABLE: "Lahan Tersedia", UNDER_REVIEW: "Verifikasi Lahan",
  RESERVED: "Dalam Proses Pemodal Kebun", INVESTED: "Sudah Mendapat Pemodal Kebun",
};
export const KEBUN_STAGE = {
  DRAFT: "RENCANA KEBUN", ACTIVE: "KEBUN AKTIF", LAND_PREPARATION: "KEBUN DALAM PEMBANGUNAN", PLANTING: "KEBUN DALAM PEMBANGUNAN",
  EARLY_GROWTH: "KEBUN AKTIF", MAINTENANCE: "KEBUN AKTIF", PRE_PRODUCTION: "KEBUN AKTIF", INITIAL_HARVEST: "KEBUN PRODUKTIF", PRODUCTIVE: "KEBUN PRODUKTIF",
};
export const OPS_STATUS = { PROBLEM: "Perlu Penanganan", SUSPENDED: "Ditangguhkan", COMPLETED: "Selesai" };
export const kebunStage = (status, approved = false) => (status === "DRAFT" && approved ? "RENCANA KEBUN DISETUJUI" : KEBUN_STAGE[status] || null);
export const PROJECT_STAGES_LEGACY = {
  DRAFT: "Persiapan", ACTIVE: "Aktif", LAND_PREPARATION: "Persiapan Lahan", PLANTING: "Penanaman Kopi",
  EARLY_GROWTH: "Pertumbuhan Awal", MAINTENANCE: "Perawatan Kebun", PRE_PRODUCTION: "Menjelang Produksi",
  INITIAL_HARVEST: "Panen Awal", PRODUCTIVE: "Kebun Produktif", PROBLEM: "Perlu Penanganan",
  COMPLETED: "Kebun Selesai", SUSPENDED: "Ditangguhkan",
};
export const PROJECT_STAGES = Object.fromEntries(Object.entries(PROJECT_STAGES_LEGACY).map(([k, v]) => [k, KEBUN_STAGE[k] ? (KEBUN_STAGE[k].toLowerCase().endsWith(v.toLowerCase()) ? KEBUN_STAGE[k] : `${KEBUN_STAGE[k]} · ${v}`) : `Status operasional: ${v}`]));
export const PROGRESS_STEPS = [
  ["VACANT", "Lahan Kosong"], ["LAND_PREPARATION", "Persiapan Lahan"], ["PLANTING", "Penanaman"],
  ["EARLY_GROWTH", "Pertumbuhan Awal"], ["MAINTENANCE", "Perawatan"], ["PRE_PRODUCTION", "Menjelang Produksi"],
  ["INITIAL_HARVEST", "Panen Awal"], ["PRODUCTIVE", "Produktif"],
];
export const progressIndex = (status) => {
  if (["DRAFT", "ACTIVE"].includes(status)) return 0;
  if (status === "COMPLETED") return PROGRESS_STEPS.length;
  return PROGRESS_STEPS.findIndex(([k]) => k === status);
};
export const EXPENSE_CATEGORIES = {
  MATERIAL: "Bahan / Pupuk", LABOR: "Tenaga Kerja", TRANSPORT: "Transport", EQUIPMENT: "Alat", PESTICIDE: "Pestisida",
  MAINTENANCE: "Pemeliharaan", HARVEST: "Panen", POSTHARVEST: "Pascapanen", OTHER: "Lainnya",
};
export const EVIDENCE = {
  BEFORE: "Foto Sebelum", DURING: "Foto Saat Kegiatan", AFTER: "Foto Sesudah", MATERIAL: "Foto Pupuk / Bahan",
  RECEIPT: "Nota / Kuitansi", GENERAL: "Foto / Video Lain", HARVEST: "Foto Hasil", ISSUE: "Foto Masalah",
};
export const SEVERITY = { LOW: "Rendah", MEDIUM: "Sedang", HIGH: "Tinggi" };
export const EDITABLE = ["DRAFT", "REVISION_REQUIRED"];

export const formatRupiah = (n) => (n == null ? "-" : `Rp${Number(n).toLocaleString("id-ID")}`);
export const formatDay = (d) =>
  d ? new Date(`${d.slice(0, 10)}T00:00:00`).toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" }) : "-";
export const mediaSrc = (m) =>
  m?.fileUrl?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${m.fileUrl}` : m?.fileUrl;

export const opts = (map) => Object.entries(map).map(([value, label]) => ({ value, label }));
export const ORG_TYPE_OPTIONS = opts(ORG_TYPES);
export const PROJECT_TYPE_OPTIONS = opts(PROJECT_TYPES);
export const VERIFY_OPTIONS = opts({ PENDING: "Menunggu Verifikasi", APPROVED: "Terverifikasi PT SJI", REJECTED: "Ditolak" });
export const COLLAB_OPTIONS = opts({ ACTIVE: "Kolaborasi Aktif", INACTIVE: "Kolaborasi Tidak Aktif" });

export const ACTIVE_OPTIONS = opts({ ACTIVE: "Aktif", INACTIVE: "Nonaktif" });
export const PROJECT_STATUS_OPTIONS = opts(PROJECT_STAGES);
export const OPPORTUNITY_OPTIONS = opts(OPPORTUNITY_STATUS);
export const COFFEE_TYPE_OPTIONS = opts(COFFEE_TYPES);
export const ROLE_OPTIONS = opts(ROLE_LABELS);
export const MEDIA_TYPE_OPTIONS = opts({ PHOTO: "Foto", VIDEO: "Video" });
export const DOC_TYPE_OPTIONS = opts({
  CONTRACT: "Kontrak", REPORT: "Laporan", LEGAL: "Legal", CERTIFICATE: "Sertifikat", OTHER: "Lainnya",
});
export const ACCESS_OPTIONS = opts({
  ADMIN_ONLY: "Hanya PT SJI", INVESTOR: "Pemodal kebun", FARMER_GROUP: "Kelompok tani kebun", PUBLIC: "Publik",
});

export const formatDate = (iso) =>
  iso
    ? new Date(iso).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : "-";
